module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"page\" name=\"page\">\n    ")
    ;  if (!widget.pagerCurrentPage) { 
    ; __append("\n    ")
    ;  for (var i = 0; i < widget.editor.length; i++) { 
    ; __append("\n    ")
    ;  var editor = widget.editor[i]; 
    ; __append("\n    <div class=\"section\">\n        <control ")
    ; __append( Html.attributes(editor) )
    ; __append(" />\n    </div>\n    ")
    ;  } 
    ; __append("\n    ")
    ;  } 
    ; __append("\n\n    <div class=\"schedule-days\" name=\"schedule-days\">\n        <div class=\"w100 section\">\n            <table name=\"list-items\" class=\"gridview__table\">\n                ")
    ;  var weak = ['Пн','Вт','Ср','Чт','Пт','Сб','Вс']; 
    ; __append("\n                ")
    ;  for (var d = 0; d <= 6; d++) { 
    ; __append("\n                <td class=\"gridview-column\">\n                    <control title=\"")
    ; __append(escapeFn( weak[d] ))
    ; __append("\" type=\"checkbox\" target=\"item.config.weak[")
    ; __append(escapeFn( d + 1 ))
    ; __append("]\"></control>\n                </td>\n                ")
    ;  } 
    ; __append("\n            </table>\n        </div>\n    </div>\n    <div class=\"schedule-parts\" name=\"schedule-parts\"></div>\n\n</div>")
  }
  return __output.join("");

}